import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import MakesItem from '../MakesItem/MakesItem';

import s from './MakesList.css';

class MakesList extends Component {
  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape().isRequired),
    itemCN: PropTypes.string,
  };

  static defaultProps = {
    list: [],
    itemCN: '',
  };

  render() {
    const { list, itemCN } = this.props;

    return (
      <div className={s.makesList}>
        {list.map(make => (
          <MakesItem
            key={make.id}
            title={make.title}
            logo={make.logo}
            models={make.models}
            link={make.link}
            className={itemCN}
          />
        ))}
      </div>
    );
  }
}

export default withStyles(s)(MakesList);



// WEBPACK FOOTER //
// ./src/desktop/components/MakesSidebar/MakesList/MakesList.js